import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Campaigns from "@/pages/Campaigns";
import CampaignNew from "@/pages/CampaignNew";
import CampaignDetail from "@/pages/CampaignDetail";
import VariationNew from "@/pages/VariationNew";
import PublishMeta from "@/pages/PublishMeta";
import Templates from "@/pages/Templates";
import Renders from "@/pages/Renders";
import Assets from "@/pages/Assets";
import Social from "@/pages/Social";
import Performance from "@/pages/Performance";
import Settings from "@/pages/Settings";
import { PrivacyPolicy, Terms, DataDeletion } from "@/pages/Legal";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-gray-400 text-sm">
        loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="light" position="bottom-right"
          toastOptions={{
            style: {
              background: "#fff",
              border: "1px solid #e5e7eb",
              color: "#1f2937",
              borderRadius: "10px",
              fontFamily: "Inter, sans-serif",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            },
          }} />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/register" element={<Public><Register /></Public>} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/campaigns" element={<Protected><Campaigns /></Protected>} />
            <Route path="/campaigns/new" element={<Protected><CampaignNew /></Protected>} />
            <Route path="/campaigns/:id" element={<Protected><CampaignDetail /></Protected>} />
            <Route path="/campaigns/:id/new" element={<Protected><VariationNew /></Protected>} />
            <Route path="/renders/:renderId/publish/meta" element={<Protected><PublishMeta /></Protected>} />
            <Route path="/templates" element={<Protected><Templates /></Protected>} />
            <Route path="/renders" element={<Protected><Renders /></Protected>} />
            <Route path="/assets" element={<Protected><Assets /></Protected>} />
            <Route path="/social" element={<Protected><Social /></Protected>} />
            <Route path="/performance" element={<Protected><Performance /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
